import React from 'react';
import { Layout, Row, Col, Typography } from 'antd';
import { Link } from 'react-router-dom';
import {
  InstagramOutlined,
  FacebookOutlined,
  MailOutlined,
  PhoneOutlined,
} from '@ant-design/icons';
import '../styles/AppFooter.css';

const { Footer } = Layout;
const { Text } = Typography;

const AppFooter = ({ setSelected }) => {
  const handleScrollToSection = (sectionId) => {
    setTimeout(() => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }, 0); // Delay to ensure the DOM is updated after navigation
  };

  return (
    <Footer
      style={{
        backgroundColor: '#202D95',
        padding: '10px 30px',
        marginTop: '50px',
      }}
    >
      {/* Row 2 */}
      <Row gutter={[16, 16]} justify="center" style={{ marginTop: '10px' }}>
        <Col xs={24} sm={12} md={12} lg={12} style={{ textAlign: 'center' }}>
          <Text
            strong
            style={{ color: 'white', fontSize: '16px', fontFamily: 'Roboto' }}
          >
            Rosario T. Vildoza 1450, Lomas de Tafí.
          </Text>
          <br />
          <Row justify="center" style={{ marginTop: '10px' }}>
            <a
              href="https://www.instagram.com/iglesiavisionapostolica.ldt/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramOutlined
                style={{
                  color: 'white',
                  marginRight: '10px',
                  fontSize: '32px',
                }}
              />
            </a>
            <a
              href="https://www.facebook.com/p/Iglesia-Visi%C3%B3n-Apostolica-LOMAS-De-TAF%C3%8D-100080234512341/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookOutlined style={{ color: 'white', fontSize: '32px' }} />
            </a>
          </Row>
        </Col>
        <Col xs={24} sm={12} md={12} lg={12} style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: '10px' }}>
            <MailOutlined
              style={{ marginRight: '8px', color: 'white', fontSize: '18px' }}
            />
            <Text
              style={{ color: 'white', fontSize: '16px', fontFamily: 'Roboto' }}
            >
              iglesiavisionapostolica@gmail.com
            </Text>
          </div>
          <div>
            <PhoneOutlined
              style={{ marginRight: '8px', color: 'white', fontSize: '18px' }}
            />
            <Text
              style={{ color: 'white', fontSize: '16px', fontFamily: 'Roboto' }}
            >
              +54 381 563-1920
            </Text>
          </div>
        </Col>
      </Row>

      {/* Row 3 */}
      <Row
        justify="center"
        className="footer-links-row" // Add a class for styling
        style={{ marginTop: '20px', marginBottom: '20px' }}
      >
        <Col>
          <Link
            to="/nuestra_fe"
            onClick={() => setSelected('Nuestra Fé')}
            className="footer-link"
            style={{
              fontFamily: 'Roboto',
            }}
          >
            Nuestra Fe
          </Link>
          <Link
            to="/kids"
            onClick={() => setSelected('Kids')}
            className="footer-link"
            style={{
              fontFamily: 'Roboto',
            }}
          >
            Kids
          </Link>
          <Link
            to="/material_lectura"
            onClick={() => setSelected('MaterialLectura')}
            className="footer-link"
            style={{
              fontFamily: 'Roboto',
            }}
          >
            Audios de cultos
          </Link>
          <Link
            to="/"
            onClick={() => {
              setSelected('Inicio'); // Set the selected state to "Inicio"
              handleScrollToSection('galeria'); // Scroll to the "galeria" section
            }}
            className="footer-link"
            style={{
              fontFamily: 'Roboto',
            }}
          >
            Galería
          </Link>
          <Link
            to="/"
            onClick={() => {
              setSelected('Inicio'); // Set the selected state to "Inicio"
              handleScrollToSection('galeria'); // Scroll to the "galeria" section
            }}
            className="footer-link"
            style={{
              fontFamily: 'Roboto',
            }}
          >
            Eventos
          </Link>
        </Col>
      </Row>
    </Footer>
  );
};

export default AppFooter;
